import { render, staticRenderFns } from "./UserRole.vue?vue&type=template&id=053ec70f&scoped=true&"
import script from "./UserRole.vue?vue&type=script&lang=ts&"
export * from "./UserRole.vue?vue&type=script&lang=ts&"
import style0 from "./UserRole.vue?vue&type=style&index=0&id=053ec70f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053ec70f",
  null
  
)

export default component.exports